export default {
  install (Vue) {
    Vue.filter('ellipsis', function (text, len) {
      text = text || ''
      return text.length > len ? text.substring(0, len) + '...' : text
    })
  }
}



/** WEBPACK FOOTER **
 ** ./src/filters/ellipsis.js
 **/